import { NAVIGATION_ROUTE_TYPES } from './routerMapConfig'
import { ROUTER_NAMES } from '@/config/router/routerNamesConfig.js'


export const COMPANY_SETTINGS_PAGES = [
	{
		path: 'profile',
		name: 'CompanyProfilePage',
		component: () => import('@/views/company/company-settings/CompanySettingsProfileView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companySettings.key,
			titleTranslationKey: 'Company Profile',
		},
	},
	{
		path: 'entities',
		name: 'CompanyProfileEntitiesPage',
		component: () => import('@/views/company/company-settings/CompanySettingsEntitiesView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companySettings.key,
			titleTranslationKey: 'menu.legalEntities',
		},
	},
	{
		path: 'user-activity',
		name: ROUTER_NAMES.COMPANY_SETTINGS.USER_ACTIVITY,
		component: () => import('@/views/company/company-settings/CompanySettingsUsersActivityView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companySettings.key,
			titleTranslationKey: 'menu.userActivity',
		},
	},
	{
		path: 'clusters',
		name: 'CompanyProfileClustersPage',
		component: () => import('@/views/company/company-settings/CompanySettingsClustersView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companySettings.key,
			titleTranslationKey: 'menu.clusters',
		},
	},
	{
		path: 'fuel',
		name: 'CompanyProfileFuelPage',
		component: () => import('@/views/company/company-settings/CompanySettingsFuelView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companySettings.key,
			titleTranslationKey: 'menu.typesOfFuel',
		},
	},
	{
		path: 'telemetry-sources',
		name: 'CompanySettingsTelemetrySourcesPage',
		component: () => import('@/views/company/company-settings/CompanySettingsTelemetrySourcesView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companySettings.key,
			titleTranslationKey: 'menu.telemetrySources',
		},
	},
]

export const COMPANY_PERSONAL_SETTINGS_PAGES = [
	{
		path: 'notifications',
		name: 'CompanyPersonalNotificationSettingsPage',
		component: () => import('@/views/company/company-personal-settings/CompanyPersonalNotificationSettingsView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.companyPersonalSettings.key,
			titleTranslationKey: 'Notifications',
		},
	},
]
